import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { FrontdeskService } from '../../services/frontdesk/frontdesk.service';
import { ToastService } from '../../services/toast/toast.service';
import { LoaderComponent } from '../../atoms/loader/loader.component';

@Component({
  selector: 'app-frontdesk-my-activity',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule, LoaderComponent],
  templateUrl: './frontdesk-my-activity.component.html',
  styleUrl: './frontdesk-my-activity.component.scss',
})
export class FrontdeskMyActivityComponent implements OnInit {
  fromDate = new FormControl('');
  toDate = new FormControl('');

  activity: any[] = [];
  isLoading: boolean = false;

  constructor(
    private frontdeskService: FrontdeskService,
    private toastService: ToastService
  ) {}

  ngOnInit(): void {
    this.load();
  }

  load(): void {
    this.isLoading = true;
    this.frontdeskService
      .getMyActivity(this.fromDate.value || undefined, this.toDate.value || undefined)
      .subscribe({
        next: (res: any) => {
          this.activity = res?.data || [];
          this.isLoading = false;
        },
        error: (err) => {
          this.activity = [];
          this.isLoading = false;
          this.toastService.error(err?.error?.message || 'Failed to load activity.');
        },
      });
  }
}
